import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(() => {


});


/*
import wixData from 'wix-data';

export function dropdown1_change(event) {
 //Add your code for this event here: 
 let myValue = $w('#dropdown1').value;
    console.log(myValue,"myvalue")
 if (myValue === 'all'){ 
$w('#dataset4').setFilter(wixData.filter());}
 else{ 
 $w("#dataset4").setFilter(wixData.filter().contains('category', myValue));
 }
} */



//*.     SLIDE SHOW FROM HERE  *//

 import wixData from 'wix-data';

$w.onReady(async function () {
	let slidesData = await getSlideshowDataFromDatabase();
	loadSlideshowData(slidesData);
});

function loadSlideshowData(slidesData) {
	const slideElements = $w("#dynamicSlideshow").slides;
	slideElements.forEach((slide, index) => {
		$w(`#${slide.id}`).background.src = slidesData[index].coverImage;
		$w(`#slideTitle${index}`).text = slidesData[index].title;
		$w(`#slideDescription${index}`).text = slidesData[index].excerpt;
      $w(`#slideDate${index}`).data = slidesData[index].publishedDate;
	  $w(`#button${index}`).link = slidesData[index].postPageUrl;
	})
} 

function getSlideshowDataFromDatabase() {



	return wixData.query("Blog/Posts").descending('publishedDate').eq("featured", true).hasSome('hashtags', 'motors').find().then(results => {
		return results.items;
	})
}



export function farmingbuttonmobile_click(event) {
 $w('#farmingbuttonmobile').hide();
	$w('#loading').show();
 wixLocation.to("/farming");

 	 wixWindow.trackEvent("CustomEvent", {
    "event": "Tab Click",
    "eventCategory": "Change to Farming Page",
    "eventAction": "Tab",
    "eventLabel": "Tab Click"
  } );
}


export function newcarsbutton_click(event) {

  wixWindow.trackEvent("CustomEvent", {
    "event": "Find New Cars Trigger",
    "eventCategory": "Find New Cars",
    "eventAction": "Click",
    "eventLabel": "Button Click Homepage"
  } );

}

export function dealercars_click(event) {
  wixWindow.trackEvent("CustomEvent", {
    "event": "Find Dealer Vehicles Trigger",
    "eventCategory": "Find Dealer Vehicles",
    "eventAction": "Click",
    "eventLabel": "Button Click Homepage"
  } );

}



export function electriccars_click(event) {
  wixWindow.trackEvent("CustomEvent", {
    "event": "Find Electric Cars Trigger",
    "eventCategory": "Find Electric Cars",
    "eventAction": "Click",
    "eventLabel": "Button Click Homepage"
  } );

}

export function clickable_click(event) {
  wixWindow.trackEvent("CustomEvent", {
    "event": "Featured Video Lightbox",
    "eventCategory": "Watch Featured Video",
    "eventAction": "Click",
    "eventLabel": "Featured Video Lightbox"
  } );

}



export function farmingtab_click(event) {
	 wixWindow.trackEvent("CustomEvent", {
    "event": "Tab Click",
    "eventCategory": "Change to Farming Page",
    "eventAction": "Tab",
    "eventLabel": "Tab Click"
  } );
  wixLocation.to("/farming");
}